import Chip from '@mui/material/Chip';
import classNames from 'classnames';
import { ReactElement } from 'react';

import styles from './ExpansionChip.module.scss';

interface IExpansionChipProps {
  className?: string;
}

const ExpansionChip = ({ className }: IExpansionChipProps): ReactElement => (
  <Chip
    label="Expansion"
    variant="outlined"
    size="small"
    className={classNames(styles.expansion, className)}
  />
);

export default ExpansionChip;
